module.exports = __webpack_public_path__ + "img/icon-info.ba01e5e3.svg";